import { Command } from 'cadenza/api-client/workbook-commands';
import { getStore } from 'cadenza/store/cadenza-store';
import type { AttributeId } from 'cadenza/workbook/model/attribute-id.gen';
import { executeCommand } from 'cadenza/workbook/workbook-core-reducers.state';

import i18n from './edit-calculated-attribute-action.properties';

export function createEditCalculatedAttributeAction(attributeId: AttributeId) {
  return {
    label: i18n('label'),
    execute: () => openEditCalculatedAttributeModal(attributeId),
  };
}

async function openEditCalculatedAttributeModal(attributeId: AttributeId) {
  const { EditCalculatedAttributeDialog } = await import(
    'cadenza/workbook/workbook-panel/databrowser/calculation-attributes/edit-calculated-attribute-dialog'
  );
  const dialog = new EditCalculatedAttributeDialog(attributeId);
  const payload = await dialog.connectAndShow();
  if (payload == null) {
    return Promise.resolve();
  } else {
    await getStore().dispatch(executeCommand(Command.EDIT_LOCAL_CALCULATED_ATTRIBUTE(payload)));
  }
}
